import { ResourcesConfig } from 'aws-amplify';

const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'eu-north-1_fRJruR9Z8',
      userPoolClientId: '6qetjg5936eq4fc6k2pmmmorgl',
      loginWith: {
        oauth: {
          domain: 'go-tailor-dev.auth.eu-north-1.amazoncognito.com',
          scopes: [
            'phone',
            'email',
            'profile',
            'openid',
            'aws.cognito.signin.user.admin',
          ],
          redirectSignIn: ['https://tailor.go-dev.entail.io/'],
          redirectSignOut: ['https://tailor.go-dev.entail.io/'],
          responseType: 'code',
        },
      },
    },
  },
};
export default amplifyConfig;
